import { KodeKotaApiPath, KodePosApiPath, KodeNegaraApiPath, KodeBankApiPath, KodeGelarApiPath, KodePekerjaanApiPath, KodeAsuransiApiPath, KodePemasokApiPath, KodeValasApiPath, KodeDnominasiApiPath, NasabahApiPath, NasabahRelasiTerkaitApiPath, NasabahRelasiUtamaApiPath, MenuIds, } from "../../../constants";
import { getWithMenu } from "../../helpers";
export const getSearchKodePos = async (searchParams) => {
    return await getWithMenu(KodePosApiPath, MenuIds.MASTER_DATA.MAIN.KODE_POS.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeKota = async (searchParams) => {
    return await getWithMenu(KodeKotaApiPath, MenuIds.MASTER_DATA.MAIN.KODE_KOTA.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeBank = async (searchParams) => {
    return await getWithMenu(KodeBankApiPath, MenuIds.MASTER_DATA.MAIN.KODE_BANK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeAsuransi = async (searchParams) => {
    return await getWithMenu(KodeAsuransiApiPath, MenuIds.MASTER_DATA.MAIN.KODE_BANK.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodePemasok = async (searchParams) => {
    return await getWithMenu(KodePemasokApiPath, MenuIds.MASTER_DATA.MAIN.KODE_PEKERJAAN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeGelar = async (searchParams) => {
    return await getWithMenu(KodeGelarApiPath, MenuIds.MASTER_DATA.MAIN.KODE_GELAR.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeValas = async (searchParams) => {
    return await getWithMenu(KodeValasApiPath, MenuIds.MASTER_DATA.MAIN.KODE_VALAS.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeDnominasi = async (searchParams) => {
    return await getWithMenu(KodeDnominasiApiPath, MenuIds.FINANCE.TELLER.SETTING.KODE_DNOMINASI.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodePekerjaan = async (searchParams) => {
    return await getWithMenu(KodePekerjaanApiPath, MenuIds.MASTER_DATA.MAIN.KODE_PEKERJAAN.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchNasabah = async (searchParams) => {
    return await getWithMenu(NasabahApiPath, MenuIds.CUSTOMER_DATA.MAIN.NASABAH.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchKodeNegara = async (searchParams) => {
    return await getWithMenu(KodeNegaraApiPath, MenuIds.MASTER_DATA.MAIN.KODE_NEGARA.id, { page: 0, size: 500, ...searchParams });
};
export const getSearchNasabahTerkait = async () => getWithMenu(NasabahRelasiTerkaitApiPath, MenuIds.CUSTOMER_DATA.MAIN.NASABAH_RELASI.id);
export const getSearchNasabahUtama = async () => getWithMenu(NasabahRelasiUtamaApiPath, MenuIds.CUSTOMER_DATA.MAIN.NASABAH_RELASI.id);
